import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var AccordionContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var AccordionHeader = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: ", ";\n  cursor: pointer;\n\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n\n  svg {\n    font-size: 24px;\n    fill: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: ", ";\n  cursor: pointer;\n\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n\n  svg {\n    font-size: 24px;\n    fill: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map